import {callAjaxGet, objectToFormData} from "../../utils";
import $ from "jquery";
import {getExternByFamily, postExtern, putExtern} from "../usuario/usuario";

//obtiene los cargos asignados de la fet
export const getCargosFet = async (errorHandling) => {
    const cargos = await callAjaxGet("GET", `${process.env.REACT_APP_API_URL}/fet/cargos`, errorHandling);
    return cargos.map(c => {
        return {
            ...c, front: diccionarioCargos[diccionarioCargos.findIndex(a => a.api_name === c.cargo)].front
        }
    })
}

//obtiene los cargos del cole asignados
export const getCargosInSchool = async (schoolId, errorHandling) => {
    const cargosCole = await callAjaxGet("GET", `${process.env.REACT_APP_API_URL}/fet/colegio/${schoolId}/cargos`, errorHandling);
    return cargosCole.map(c => {
        return {
            ...c, front: diccionarioCargosCole[diccionarioCargosCole.findIndex(a => a.api_name === c.cargo)].front
        }
    })
 }

export const getCargoFetById = async (chargeId, errorHandling) => {
    const cargo = await callAjaxGet("GET", `${process.env.REACT_APP_API_URL}/fet/cargos/${chargeId}`, errorHandling);
    return {
        ...cargo,
        front: diccionarioCargos[diccionarioCargos.findIndex(a => a.api_name === cargo.cargo)].front
    }
}

export const getPeopleByCargoFet = async (charge, errorHandling) => {
    return await callAjaxGet("GET", `${process.env.REACT_APP_API_URL}/fet/cargos?cargo=${charge}`, errorHandling);
}

//obtener colegios de la fet jose
export const getColegios = async (errorHandling) => {
    return await callAjaxGet("GET", `${process.env.REACT_APP_API_URL}/fet/colegios`, errorHandling);
}

export const getCargosExtHerFet = async (errorHandling) => {
    const cargos = (await callAjaxGet("GET", `${process.env.REACT_APP_API_URL}/familia/disponibles`, errorHandling)).fet;
    cargos.cargosHer = cargos.cargosHer.map(c => diccionarioCargos.find(d => d.api_name === c).front);
    cargos.cargosExt = cargos.cargosExt.map(c => diccionarioCargos.find(d => d.api_name === c).front);
   
    return cargos;
};

//obtener los cargos disponibles en el colegio, llamando al diccionario de cargos del cole y comparándolo con los cargos del colegio
export const getCargosExtHerColegio = async (errorHandling) => {
    const cargos = (await callAjaxGet("GET", `${process.env.REACT_APP_API_URL}/familia/disponibles`, errorHandling)).colegio;
    cargos.cargosHer = cargos.cargosHer.map(c => diccionarioCargosCole.find(d => d.api_name === c).front);
    cargos.cargosExt = cargos.cargosExt.map(c => diccionarioCargosCole.find(d => d.api_name === c).front);
   
    return cargos;
};

// export const getPeopleByCargoInSchool = async (schooldId, charge, errorHandling) => {
//     return await callAjaxGet("GET", `${process.env.REACT_APP_API_URL}/fet/colegio/${schoolId}?cargo=${charge}`, errorHandling);
// }

// Lo usamos para traducir entre los nombres de los cargos en la api y los cargos en el frontend
const diccionarioCargosCole = [
    {
        api_name: "Director/a general",
        front: {name: "Equipo directivo del colegio", charge: "Director/a general"}
    },
    {
        api_name: "Director/a pedagogico de educacion infantil-primaria",

        front: {name: "Equipo directivo del colegio", charge: "Director/a pedagógico de educación infantil-primaria"}
    },
    {
        api_name: "Director/a pedagogico de educacion secundaria",
        front: {name: "Equipo directivo del colegio", charge: "Director/a pedagógico de educación secundaria"}
    },
    {
        api_name: "Coordinador/a ciclos formativos",
        front: {name: "Equipo directivo del colegio", charge: "Coordinador/a ciclos formativos"}
    },
    {
        api_name: "Coordinador/a de pastoral",
        front: {name: "Equipo directivo del colegio", charge: "Coordinador/a de pastoral"}
    },
    {
        api_name: "Administración",
        front: {name: "Hermanas que trabajan en el colegio", charge: "Administración"}
    },
    {
        api_name: "Docencia",
        front: {name: "Hermanas que trabajan en el colegio", charge: "Docencia"}
    },
    {
        api_name: "Equipo de pastoral",
        front: {name: "Hermanas que trabajan en el colegio", charge: "Equipo de pastoral"}
    },
    {
        api_name: "Equipo de innovación",
        front: {name: "Hermanas que trabajan en el colegio", charge: "Equipo de innovación"}
    },
    {
        api_name: "Mantenimiento",
        front: {name: "Hermanas que trabajan en el colegio", charge: "Mantenimiento"}
    },
    {
        api_name: "Orientación",
        front: {name: "Hermanas que trabajan en el colegio", charge: "Orientación"}
    },
    {
        api_name: "Secretaría",
        front: {name: "Hermanas que trabajan en el colegio", charge: "Secretaría"}
    },
    {
        api_name: "Servicios escolares",
        front: {name: "Hermanas que trabajan en el colegio", charge: "Servicios escolares"}
    },
    {
        api_name: "Otro cargo (Hermana)",
        front: {name: "Hermanas que trabajan en el colegio", charge: "Otros cargos"}
    },
    {
        api_name: "Administrador/a",
        front: {name: "Equipo directivo del colegio", charge: "Administrador/a"}
    },
]

const diccionarioCargos = [
    {
        api_name: "Presidenta Patronato",
        front: {name: "Patronato", charge: "Presidenta"}
    },
    {
        api_name: "Vicepresidenta Patronato",
        front: {name: "Patronato", charge: "Vicepresidenta"}
    },
    {
        api_name: "Secretaria Patronato",
        front: {name: "Patronato", charge: "Secretaria"}
    },
    {
        api_name: "Vocal Patronato",
        front: {name: "Patronato", charge: "Vocales"}
    },
    {
        api_name: "Presidenta comision permanente",
        front: {name: "Comisión permanente", charge: "Presidenta"}
    },
    {
        api_name: "Miembro del patronato",
        front: {name: "Comisión permanente", charge: "Miembros patronato"}
    },
    {
        api_name: "Director/a general",
        front: {name: "Equipo titularidad", charge: "Director/a general"}
    },
    {
        api_name: "Director/a area pastoral",
        front: {name: "Equipo titularidad", charge: "Director/a pastoral"}
    },
    {
        api_name: "Director/a area pedagogica",
        front: {name: "Equipo titularidad", charge: "Director/a pedagógica"}
    },
    {
        api_name: "Director/a administrativo/a",
        front: {name: "Equipo titularidad", charge: "Director/a administrativo/a"}
    },
    {
        api_name: "Pastoral permanente area",
        front: {name: "Equipo permanente area", charge: "Pastoral"}
    },
    {
        api_name: "Pedagógico permanente area",
        front: {name: "Equipo permanente area", charge: "Pedagógico"}
    },
    {
        api_name: "Formación permanente area",
        front: {name: "Equipo permanente area", charge: "Formación"}
    },
    {
        api_name: "Administración permanente area",
        front: {name: "Equipo permanente area", charge: "Administración"}
    },
    {
        api_name: "Comunicación",
        front: {name: "Servicios centrales", charge: "Comunicación"}
    },
    {
        api_name: "Secretaria de Dirección general",
        front: {name: "Servicios centrales", charge: "Secretaria de Dirección general"}
    },
    {
        api_name: "Apoyo area de Administración y Formación",
        front: {name: "Servicios centrales", charge: "Apoyo area de Administración y Formación"}
    },
    {
        api_name: "Servicio de Gestión Laboral para centros",
        front: {name: "Servicios centrales", charge: "Servicio de Gestión Laboral para centros"}
    },
    {
        api_name: "Recursos humanos y personal",
        front: {name: "Servicios centrales", charge: "Recursos humanos y personal"}
    }]

export const postCargoFet = async (cargo) => {
    let settings = {
        url: process.env.REACT_APP_API_URL + `/fet/cargos`,
        method: "POST",
        xhrFields: {
            withCredentials: true,
        },
        contentType: false,
        processData: false,
        data: cargo,
    };
    return $.ajax(settings);
};

//añade cargo de la fet
export const putCargoFet = async (cargo, id) => {   
    let settings = {
        url: process.env.REACT_APP_API_URL + `/fet/cargos/${id}`,
        method: "PUT",
        xhrFields: {
            withCredentials: true,
        },
        contentType: false,
        processData: false,
        data: cargo,
    };
    return $.ajax(settings);
};

//borra cargo de la fet
export const deleteCargoFet = async (id) => {
    let settings = {
        url: process.env.REACT_APP_API_URL + `/fet/cargos/${id}`,
        method: "DELETE",
        xhrFields: {
            withCredentials: true,
        },
        contentType: false,
        processData: false,
    };
    return $.ajax(settings);
};

//funcion para poner los cargos de la fet
export const formPostFet = async (nuevos, aBorrar) => {
    const promises = [];
    nuevos.forEach(nuevo => {
        const form = objectToFormData({
            startDate: nuevo.startDate,
            endDate: nuevo.endDate,
            cargo: diccionarioCargos.find(c => c.front.name === nuevo.front.name && c.front.charge === nuevo.front.charge).api_name,
            externoId: nuevo.externoId,
            sisterId: nuevo.sisterId,

        }, true);
        if (nuevo.id) {
            promises.push(putCargoFet(form, nuevo.id))
           // console.log('actualizo '+nuevo.id)
        } else {
            promises.push(postCargoFet(form))
          //  console.log('nuevo '+nuevo.id)
        }
    });

    aBorrar.forEach(borrar => {
        promises.push(deleteCargoFet(borrar.id))
    })

    for (let promise in promises) {
        try {
            await promise;
        } catch (e) {
            alert(e)
        }
    }
}

//post cargo cole
export const postCargoCole = async (cargo, coleid) => {
    let settings = {
        url: process.env.REACT_APP_API_URL + `/fet/colegio/${coleid.valor}/cargos`,
        method: "POST",
        xhrFields: {
            withCredentials: true,
        },
        contentType: false,
        processData: false,
        data: cargo,
    };
    return $.ajax(settings);
};

//put cargo cole
export const putCargoCole = async (cargo, id, coleid) => {
     let settings = {
        url: process.env.REACT_APP_API_URL + `/fet/colegio/${coleid.valor}/cargos/${id}`,
        method: "PUT",
        xhrFields: {
            withCredentials: true,
        },
        contentType: false,
        processData: false,
        data: cargo,
    };
    return $.ajax(settings);
};

//borra cargo de la fet
export const deleteCargoCole = async (id, coleid) => {
    let settings = {
        url: process.env.REACT_APP_API_URL + `/fet/colegio/${coleid.valor}/cargos/${id}`,
        method: "DELETE",
        xhrFields: {
            withCredentials: true,
        },
        contentType: false,
        processData: false,
    };
    return $.ajax(settings);
};

//funcion para poner los cargos de los coles jose 032022
export const formPostColes = async (nuevos, aBorrar, colegioid) => {
    //array de peticiones
    const promises = [];
    //por cada elemento nuevo creo un objeto correcto y completo
    nuevos.forEach(nuevo => {
        const form = objectToFormData({
            startDate: nuevo.startDate,
            endDate: nuevo.endDate,
            cargo: diccionarioCargosCole.find(c => c.front.name === nuevo.front.name && c.front.charge === nuevo.front.charge).api_name,
            externoId: nuevo.externoId,
            sisterId: nuevo.sisterId,
            colegioFetId: colegioid.valor,
        }, true);
    
        if (nuevo.id) {
            promises.push(putCargoCole(form, nuevo.id, colegioid))
        } else {
            promises.push(postCargoCole(form, colegioid))
        }
    });


    aBorrar.forEach(borrar => {
        const  res =  promises.push(deleteCargoCole(borrar.id, colegioid));
        //console.log('resultado '+res)
    })

    //llamo al array de peticiones y las ejecuto
    for (let promise in promises) {
        try {
            await promise;
        } catch (e) {
            alert(e)
        }
    }
}

export const getExternFet = async (errorHandling, name = null) => {
    return await getExternByFamily("FET", errorHandling, name);
}

export const postExternFet = async (data) => {
    await postExtern({...data, familia: "FET"});
};

export const putExternFet = async (data) => {
    await putExtern({...data, familia: "FET"});
};